export const ESTADOS_RENOVACION = {
  POR_RENOVAR: "POR_RENOVAR",
  EN_PROCESO: "EN_PROCESO",
  EN_PROCESO_2: "EN_PROCESO_2",
  PROVISIONAL_SOLICITADA: "PROVISIONAL_SOLICITADA",
  NO_SINIESTROS_SOLICITADA: "NO_SINIESTROS_SOLICITADA",
  NO_SINIESTROS_FIRMADA: "NO_SINIESTROS_FIRMADA",
  NO_RENOVABLE: "NO_RENOVABLE",
  FVP: "FVP",
  FVC: "FVC",
  ES: "ES",
  RENOVADA: "RENOVADA",
  VENCIDAS: "VENCIDAS",
  NO_RENOVADAS: "NO_RENOVADAS",
  ADS: "ADS",
  EMISION_TRADICIONAL: "ET",
  BROKER_PAGADO: "BP",
  EMISION_FINALIZADA: "EF",
  FIRMA_ELECTRONICA_SOLICITADA: "FES",
  FIRMA_ELECTRONICA_COMPLETADA: "FEC",
};

export const COMENTARIO_LOB = {
  NO_RENOVAR: "no renovar",
  NO_RENOVAR_SUSCRIPCION: "no renovar por políticas de suscripción",
  MODIFICAR_CONDICIONES: "para la renovación se modifican condiciones",
  MANTENER_CONDICIONES: "se mantienen las mismas condiciones",
  MANTENER_CONDICIONES_PYMES: "para la renovación se mantienen mismas condiciones",
};

export const esComentarioMantenerCondiciones = (comentario) => {
  if (!comentario) return false;
  const texto = comentario.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return texto.includes("mantienen") && texto.includes("condiciones");
};

export const COMENTARIO_LOB_BLOQUEADOS = [
  COMENTARIO_LOB.NO_RENOVAR,
  COMENTARIO_LOB.NO_RENOVAR_SUSCRIPCION,
];

export const MENSAJES_COMENTARIO_LOB = {
  [COMENTARIO_LOB.NO_RENOVAR]: "Póliza no disponible para renovación",
  [COMENTARIO_LOB.NO_RENOVAR_SUSCRIPCION]: "Póliza no disponible para renovación",
};

export const PRODUCTOS = {
  AIG_AUTO: "AIG AUTO",
  PRACTIAUTO: 'PRACTIAUTO',
  KILOMETROS_PAQUETE: 'Kilómetros paquete'
};

export const MENSAJES_ESTADOS = {
  [ESTADOS_RENOVACION.POR_RENOVAR]: "La póliza está pendiente de renovación.",
  [ESTADOS_RENOVACION.EN_PROCESO]: "La póliza se encuentra en proceso de renovación.",
  [ESTADOS_RENOVACION.EN_PROCESO_2]: "La póliza continúa en proceso de renovación (fase 2).",
  [ESTADOS_RENOVACION.PROVISIONAL_SOLICITADA]: "Se ha solicitado la emisión provisional de la póliza.",
  [ESTADOS_RENOVACION.NO_SINIESTROS_SOLICITADA]: "Se ha solicitado la carta de no siniestros.",
  [ESTADOS_RENOVACION.NO_SINIESTROS_FIRMADA]: "La carta de no siniestros ha sido firmada.",
  [ESTADOS_RENOVACION.NO_RENOVABLE]: "La póliza no es renovable.",
  [ESTADOS_RENOVACION.FVP]: "La póliza está en fase de Firma de Valores Pendiente.",
  [ESTADOS_RENOVACION.FVC]: "La póliza está en fase de Firma de Valores Confirmada.",
  [ESTADOS_RENOVACION.ES]: "Estado especial de la póliza.",
  [ESTADOS_RENOVACION.RENOVADA]: "La póliza ha sido renovada exitosamente.",
  [ESTADOS_RENOVACION.VENCIDAS]: "La póliza ha vencido.",
  [ESTADOS_RENOVACION.NO_RENOVADAS]: "La póliza no fue renovada.",
  [ESTADOS_RENOVACION.ADS]: "La póliza está pendiente de Autorización de Débito Bancario Solicitada.",
  [ESTADOS_RENOVACION.BROKER_PAGADO]: "La póliza ha sido pagada por el broker.",
  [ESTADOS_RENOVACION.EMISION_FINALIZADA]: "La póliza ha finalizado su proceso de emisión.",
  [ESTADOS_RENOVACION.FIRMA_ELECTRONICA_SOLICITADA]: "Se ha solicitado la firma electrónica de la póliza.",
  [ESTADOS_RENOVACION.FIRMA_ELECTRONICA_COMPLETADA]: "La firma electrónica ha sido completada.",
};

export const RAMOS_OPTIONS = [
  { label: "Todas", value: "TODAS" },
  { label: "Auto", value: "VEHICULOS PERSONALES" },
  { label: "Pymes", value: "PYMES" },
];
